import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class LowerThanDirective extends ComparisonDirective {
public ngLowerThan: any;
constructor() {
    super('ngLowerThan');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value < this.ngLowerThan;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngLowerThan]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: LowerThanDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngLowerThan': [{ type: Input },],
};
}

function LowerThanDirective_tsickle_Closure_declarations() {
/** @type {?} */
LowerThanDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LowerThanDirective.ctorParameters;
/** @type {?} */
LowerThanDirective.propDecorators;
/** @type {?} */
LowerThanDirective.prototype.ngLowerThan;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
